import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { downloadFile, fetchFiles } from "../../../api/files";
import RecentCatalogs from "../../../components/recents/RecentCatalogs";
import RecentManuals from "../../../components/recents/RecentManuals";
import RecentPromotions from "../../../components/recents/RecentPromotions";
import RecentSkirts from "../../../components/recents/RecentSkirts";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";
import SmuCarousel from "../../../utils/smu-carousel/SmuCarousel";
import { fetchBanners } from "../../../api/banners";
import { fetchCatalogs } from "../../../api/catalogs";
import { fetchPromotions } from "../../../api/promotions";
import {
  MANUALS_CATEGORY,
  SKITRS_CATEGORY,
} from "../../../constants/categories";

const brand = process.env.REACT_APP_BRAND || "M10";

const Home = () => {
  const { topPromotions, topCatalogs, topManuals, topSkirts, 
          banners, setTopPromotions, setTopManuals, setTopSkirts, 
          setBanners, setTopCatalogs, setPdfForPreview } =
    useContext(StoreContext);
  const [downloading, setDownloading] = useState(null);

  const [loadingPromotions, setLoadingPromotions] = useState(true);

  const download = (category, fileId) => {
    setDownloading(fileId);

    downloadFile(category, fileId)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);

        const {
          url,
          document: { filename },
        } = data;

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setDownloading(null));
  };

  useEffect(() => {

    const handleFetchTopPromotions = async () => {
      setTopPromotions([])
      setLoadingPromotions(true);
      const { data, error } = await fetchPromotions(brand, 333, 5);
      if (error) return;
      setTopPromotions(data || []);
      setLoadingPromotions(false);
    };

    const handleFetchTopManuals = async () => {
      const { data, error } = await fetchFiles(MANUALS_CATEGORY, 5);
      if (error) return;
      const topManuals = data?.data?.documents || [];
      setTopManuals(topManuals);
    };
  
    const handleFetchTopSkirts = async () => {
      const { data, error } = await fetchFiles(SKITRS_CATEGORY, 5);
      if (error) return;
      const topSkirts = data?.data?.documents || [];
      setTopSkirts(topSkirts);
    };
  
    const handleFetchBanners = async () => {
      const { data, error } = await fetchBanners();
      if (error) return;
      const banners = data?.data?.documents || [];
      setBanners(banners);
    };

    const handleFetchCatalogs = async () => {
      const { data, error } = await fetchCatalogs();
      if (error) return;
      const catalogs = data?.data?.details || [];
      setTopCatalogs(catalogs.slice(0, 5));
      if (catalogs?.length > 0) setPdfForPreview(catalogs[0]);
    };

    handleFetchTopPromotions();
    handleFetchCatalogs();
    handleFetchTopManuals();
    handleFetchTopSkirts();
    handleFetchBanners();

  }, [])

  return (
    <Row>
      <Col col={12} className="col-7 mb-4">
        <SmuCarousel banners={banners} />
      </Col>
      <Col col={12} className="col-5 mb-4">
        <RecentPromotions promotions={topPromotions} loading={loadingPromotions} />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentSkirts
          skirts={topSkirts}
          download={download}
          downloading={downloading}
        />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentManuals
          manuals={topManuals}
          download={download}
          downloading={downloading}
        />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentCatalogs
          catalogs={topCatalogs}
          download={download}
          downloading={downloading}
        />
      </Col>
    </Row>
  );
};

export default Home;
